function init() {
  import('./bootstrap').then(mod => {
    mod.default()
  })
}
function check() {
  if (!window.fetch) {
    init()
  } else {
    const url = new URL(location.href)
    const pname = url.pathname

    const hasTab = !!url.searchParams.get('tab')
    const noNeedRedirect = ['cake', 'freemium'].includes(url.searchParams.get('source') || '')
    const isHome = pname === '/home-learning/'

    if (noNeedRedirect || hasTab) {
      init()
    } else {
      if (isHome) {
        fetch('https://system.baicizhan.com/api/system/course_redirect_url', {
          credentials: 'include',
        })
          .then(res => res.json())
          .then(res => {
            if (res.data) {
              const url = new URL(res.data)
              url.searchParams.set('origin', location.href)
              window.location.replace(url.toString())
            } else {
              init()
            }
          })
          .catch(init)
      } else {
        init()
      }
    }
  }
}

check()
